import React from "react";
import { useTranslation } from "react-i18next";

import {
  Subscription,
  ThreeElements,
  ClassPrice,
  Custom,
  PriceLabel,
  Price,
} from "./TotalAmountStyle";

export const renderCurrency = (currency: string) => {
  if (currency === "usd") return "$";
  if (currency === "eur") return "€";
  if (currency === "sgd") return "S$";
  if (currency === "krw") return "₩";
  if (currency === "gbp") return "£";
  if (currency === "aud") return "A$";
  if (currency === "cad") return "C$";
  if (currency === "jpy") return "¥";
  if (currency === "vnd") return "₫";
  return "";
};

type TotalAmountPropsType = {
  classPrice: number;
  discountAmount: number;
  currency: string;
  haveFreeTrial: boolean;
  isPackage: boolean;
};

const TotalAmount = ({
  classPrice,
  discountAmount,
  currency,
  haveFreeTrial,
  isPackage,
}: TotalAmountPropsType) => {
  const { t } = useTranslation("new_sign_up");

  const ifPriceGotTooLong = (numb: number) => {
    // when price gets longer than 3 digits, add a comma
    const str = numb.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
  };

  return (
    <>
      <Custom style={{ color: "black" }} />
      <ThreeElements>
        <PriceLabel>
          {haveFreeTrial && !isPackage && t("Continue After Trial")}
          {!haveFreeTrial && !isPackage && t("Pay every 4 weeks")}
          {haveFreeTrial && isPackage && t("Payment after Trial")}
          {!haveFreeTrial && isPackage && t("Non-Recurring Payment")}
        </PriceLabel>
        <Price>
          {renderCurrency(currency)} {ifPriceGotTooLong(classPrice)}
        </Price>
      </ThreeElements>

      {discountAmount !== 0 ? (
        <>
          <ThreeElements>
            <Subscription>{t("Discount")}</Subscription>
            <ClassPrice>
              - {renderCurrency(currency)} {ifPriceGotTooLong(discountAmount)}
            </ClassPrice>
          </ThreeElements>
          <Custom />
          <ThreeElements>
            <PriceLabel>
              {haveFreeTrial ? t("New Total After Trial") : t("New Total")}
            </PriceLabel>
            <Price>
              {renderCurrency(currency)}{" "}
              {ifPriceGotTooLong(Math.max(classPrice - discountAmount, 0))}
            </Price>
          </ThreeElements>
        </>
      ) : null}
    </>
  );
};
export default TotalAmount;
